// Modules
import React from 'react';
import Link from 'next/link';
// Utils
import { isEmpty } from '~/utils';
import api from '~/services/api';
import actions from '~/services/log-actions';
// Icons
import ArrowLeftIcon from '~/assets/images/arrow-left.svg';
// Styles
import styles from './breadcrumbs.module.scss';

const Breadcrumbs = ({ items }) => {
  const handleClickCrumb = (title) => {
    api.sendLog(actions.BREADCRUMB_CLICK, { title });
  };

  return (
    <div className={styles['wrapper']}>
      {items?.map((crumb, i) => {
        const isLastItem = i === items.length - 1;

        return (
          !isEmpty(crumb.label) && (
            <React.Fragment key={i}>
              <Link
                href={crumb.path}
                className={styles['wrapper__route']}
                onClick={() => handleClickCrumb(crumb.label)}
              >
                {crumb.label}
              </Link>
              {!isLastItem && <ArrowLeftIcon />}
            </React.Fragment>
          )
        );
      })}
    </div>
  );
};
export default Breadcrumbs;
